<template>
  <BaseModal
    :show="open"
    @close="close"
  >
    <div class="mb-8 text-center modal-body">
      <header class="pb-4 text-center border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Verify Auth Code'"
        />
      </header>
    </div>
    <div>
      <div class="flex flex-col items-baseline justify-center mt-2">
        <p
          class="text-sm whitespace-no-wrap text-grey-darker"
          v-text="'To continue, please enter the 6-digit verification code sent to your phone.'"
        />
        <div class="w-full px-8 text-left">
          <label
            for="auth_code"
            v-text="'Auth Code'"
          />
          <input
            id="auth_code"
            v-model="code"
            autofocus="autofocus"
            name="auth_code"
            placeholder="000000"
            required="required"
            type="text"
            value
            autocomplete="off"
          >
          <span
            v-if="error"
            class="text-red text-xs"
            v-text="error"
          />
        </div>
      </div>
    </div>
    <div class="mt-4 text-center modal-footer">
      <button
        type="button"
        class="mr-2 btn"
        :disabled="!authCodeId"
        :aria-disabled="!authCodeId"
        @click.prevent="submit"
        v-text="'Submit'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'AuthCodeModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      authCodeId: null,
      code: null,
      error: null,
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.$api.active().post('send-auth-code').then(({ data }) => {
          this.authCodeId = data.auth_code_id
        })
      }
    },
  },
  methods: {
    close() {
      this.$emit('closeModal')
    },
    submit() {
      this.error = null

      this.$api
        .public()
        .post(`auth-codes/${this.authCodeId}/verify`, {
          'auth_code': this.code,
        })
        .then(({ data }) => {
          if (data.status == 'success') {
            this.$emit('authCodeVerified')
          }
        }).catch(({ response }) => {
          this.error = response.data.message
        })
    },
  },
}
</script>
